import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AdminDriverGrid extends BaseComponent {
	
	static get properties() {
		return {
			accountmanagement: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		this.accountmanagement = false;
		
		var adminDriverGrid = this;
		setTimeout(function(){
			adminDriverGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var adminDriverGrid = this;
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (adminDriverGrid.accountmanagement) {
							Service.getAccountManagementService().getManagedCompanies().then(function(data){
								var lookups = []; 
								data.forEach(function(c) {
									lookups.push({
										code: c.companyId,
										description: c.companyName
									});
								});
								combo.items = lookups;
							});
						} else {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							adminDriverGrid.selectedCompanyId = ElementUtil.query(toolbarFilter, 'filterCompany').value;
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							},
							{
								code: 'STG',
								desc: 'Stage'
							},
							{
								code: 'D',
								desc: 'Soft Delete'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'driverRefNo',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'driverId',
								description: 'Driver Id'								
							},
							{
								code: 'driverRefNo',
								description: 'Reference No'	
							},
							{
								code: 'firstName',
								description: 'First Name'	
							},
							{
								code: 'lastName',
								description: 'Last Name'	
							},
							{
								code: 'comment',
								description: 'Comment'	
							},							
							{
								code: 'tags',
								description: 'Tag'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},			
				{
					tag: 'div',
					style: 'float: right;',
					children:[						
						{
							tag: 'dl-action-button',
							itemid: 'deleteStage',
							theme: 'error primary',
							'class': 'spacer-toolbar-item',					
							permissions: ['ADMIN_DRIVERS:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:close', 'Delete Staging')						
							],
							listeners: {
								click: function() {
									actionDeleteStage(grid.selectedItems);
								}
							}							
						},						
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							theme: 'error primary',					
							permissions: ['ADMIN_DRIVERS:DELETE'],
							'class': 'spacer-toolbar-item',								
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},				
				{						
					path: 'driverId',
					header: 'Driver Id',
					width: '7em'
				},	
				{						
					path: 'driverRefNo',
					header: 'Driver Ref No',
					width: '7em'
				},
				{						
					path: 'firstName',
					header: 'First Name',
					width: '7em'
				},
				{						
					path: 'lastName',
					header: 'Last Name',
					width: '7em'
				},
				{						
					path: 'driverTypeDescription',
					header: 'Driver Type',
					width: '7em'
				},
				{						
					path: 'comment',
					header: 'Comment',
					width: '7em'
				},
				{						
					path: 'tags',
					header: 'Tags',
					width: '12em',
					renderer: function(root, column, rowData) {
						var tags = [];
						if (rowData.item.tags) {
							rowData.item.tags.forEach(function(tagItem) {
								tags.push(
									'<span class="tag-badge" style="margin: 3px;">' + tagItem + '</span>'
								);
							});
						}
						
						root.innerHTML = tags.join('');
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {					  
					var status = ElementUtil.query(toolbarFilter, 'status').value;
					
					ElementUtil.query(toolbar, 'delete').disabled = false;
					if ('STG' === status) {
						ElementUtil.query(toolbar, 'deleteStage').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'deleteStage').disabled = true; 						
					}
				} else {						
					ElementUtil.query(toolbar, 'delete').disabled = true;			
					ElementUtil.query(toolbar, 'deleteStage').disabled = true; 											
				}
			});
		};	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var selectedCompany = ElementUtil.query(toolbarFilter, 'filterCompany').value;
					if (!selectedCompany) {						
						window.DL.MessageUtil.showToastError('A company must be selected.');
						return;
					}
					adminDriverGrid.selectedCompanyId = selectedCompany;
					
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',							
							status: ElementUtil.query(toolbarFilter, 'status').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
						
						var successHandler = function(records) {
							loadMask.remove();
							
							grid.items = records.data;
							grid.selectedItems = [];
							grid.activeItem = null;	
							// Weird timing issue with clearing the selection
							setTimeout(function(){
								gridSelectionChange();
							}, 25);

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						
						grid.currentFilter.companyId = selectedCompany;
						UnitService.getAdminUnitService().getDrivers(selectedCompany, grid.currentFilter).then(function(records){
							successHandler(records);
						});
																			
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'driver',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				UnitService.getDriverService().exportDriver(exportFilter);
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		adminDriverGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(adminDriverGrid, toolbarFilter, ['filterCompany','status','filterType','filterValue'], actionRefresh);
			
		var actionDeleteStage = function(records) {
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.driverId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected driver(s) from staging?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getAdminUnitService().deleteStageDriver(adminDriverGrid.selectedCompanyId, requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});			
			
		};
	
		var actionDelete = function(records) {
	
			var requestModel = {
				ids: []
			};			
			records.forEach(function(item){				
				requestModel.ids.push(item.driverId);
			});
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected driver(s)? <br>They will be marked Soft Delete immediately and removed in a background task.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							UnitService.getAdminUnitService().deleteDriversBulk(adminDriverGrid.selectedCompanyId, requestModel)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Driver removal scheduled. Marked Soft Delete (see Tasks).', {									
									theme: 'success'
								});
								actionRefresh();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};	
		
	}
	
}
customElements.define('dl-admin-driver-grid', AdminDriverGrid);
